import angular from 'angular'
import { max } from 'lodash'
import { getReportEndDate } from './helpers'

export default function() {
  return {
    restrict: 'EA',
    template: require('./_enhanced_reports.html'),
    controller: [
      '$scope',
      '$q',
      'analyticsApi',
      function($scope, $q, analytics) {
        var rawDomainsReport
        var monthArray = [
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
          'January',
          'February',
          'March',
          'April',
          'May',
          'June'
        ]
        var monthVals = [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6]
        // -- Scope bound funcs --

        $scope.displayDomainList = function() {
          $scope.selected_domain_uuid = ''
        }

        // Filters for Domain list
        $scope.domainListFilter = function(domain) {
          if (
            domain.activated_users < $scope.activated_users_threshold ||
            domain.provisioned_users < $scope.provisioned_users_threshold ||
            domain.activation_percentage < $scope.activation_percentage_threshold ||
            ($scope.selected_domain_uuid != '' && $scope.selected_domain_uuid != domain.uuid)
          ) {
            return false
          }
          return true
        }

        // Display user list for a domain
        $scope.selected_domain_uuid = ''
        $scope.displayUserList = function(product, domainUuid, selectedSchoolYear, selectedMonth) {
          createDomainUserList(product, domainUuid, selectedSchoolYear, selectedMonth)

          $scope.selected_domain_uuid = domainUuid
        }

        // Filters for User List
        $scope.userListFilter = function(user) {
          if (
            ($scope.hide_inactive && user.activation_date === '-') ||
            ($scope.hide_active && user.activation_date !== '-') ||
            user.resources_accessed < $scope.resources_accessed_threshold
          ) {
            return false
          }
          return true
        }

        // Display domain list with activations
        $scope.fetchingDomainsListReport = false
        $scope.fetchDomainList = async (schoolYear, selectedMonth) => {
          $scope.fetchingDomainsListReport = true
          $scope.fetchingDomainsListReportError = null

          try {
            rawDomainsReport = await analytics.getAnalyticsReport(
              `domains_${$scope.productType}_overview_nouserinfo`,
              {
                sdate: `${schoolYear}-07-01`,
                edate: `${schoolYear + 1}-06-30`,
                database: 'redshift'
              }
            )
            createDomainList(rawDomainsReport, selectedMonth)
          } catch (err) {
            $scope.fetchingDomainsListReportError = JSON.stringify(err)
          }
          $scope.fetchingDomainsListReport = false
        }

        // -- Helper Funcs --

        function createDomainList(rawDomainsReport, selectedMonth) {
          $scope.domainsList = rawDomainsReport[0]['Report']
            .map(function(domain) {
              var provisionedUsers = domain['enterprise count'],
                activatedUsers = domain[`${selectedMonth.name.toLowerCase()} activated users`],
                activatedPct = domain[`${selectedMonth.name.toLowerCase()} activation %`],
                activatedEngagementPct = domain[`${selectedMonth.name.toLowerCase()} engagement %`],
                engagedUsers = Math.round(activatedUsers * activatedEngagementPct / 100),
                totalEngagementPct =
                  provisionedUsers == 0 ? 0 : Math.round(engagedUsers / provisionedUsers * 100)

              var domain = {
                uuid: domain['domain uuid'],
                name: domain['domain name'],
                provisioned_users: provisionedUsers,
                activated_users: activatedUsers,
                engaged_users: engagedUsers,
                activation_percentage: activatedPct,
                total_engagement_percentage: totalEngagementPct,
                activated_engagement_percentage: activatedEngagementPct
              }

              return domain
            })
            .sort(function(a, b) {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              return 0
            })
        }

        $scope.fetchingUsersReport = false
        function createDomainUserList(product, domainUuid, selectedSchoolYear, selectedMonth) {
          var domain_user_list = []
          var reportEndDateYYYYMMDD = getReportEndDate(selectedSchoolYear, selectedMonth.value)

          $scope.fetchingUsersReport = true

          $q
            .all({
              domain_analytics: analytics.getAnalyticsReport('domain_analytics', {
                domainUuid: domainUuid,
                sdate: `${selectedSchoolYear}-07-01`,
                edate: reportEndDateYYYYMMDD,
                database: 'redshift'
              }),
              user_activation_info: analytics.getAnalyticsReport('user_activation_info', {
                domainUuid: domainUuid,
                product: $scope.productType,
                sdate: `${selectedSchoolYear}-07-01`,
                edate: reportEndDateYYYYMMDD,
                database: 'redshift'
              })
            })
            .then(
              function(resolved) {
                // Shift value is used to determine which rows to read from domain analytics report
                var shift = $scope.productType == 'toolkit' ? 3 : 0

                var domainAnalytics = resolved['domain_analytics'] || [],
                  userActivationInfo = resolved['user_activation_info'] || []

                var detailedReport = domainAnalytics[0 + shift]['Report'],
                  detailedHeaders = domainAnalytics[0 + shift]['ReportHeaders'],
                  summarisedReport = domainAnalytics[1 + shift]['Report'],
                  summarisedHeaders = domainAnalytics[1 + shift]['ReportHeaders'],
                  unactivatedReport = domainAnalytics[2 + shift]['Report'],
                  unactivatedHeaders = domainAnalytics[2 + shift]['ReportHeaders'],
                  userActivations = userActivationInfo[0]['Report']

                var nameIdx = detailedHeaders.indexOf('Name'),
                  emailIdx = detailedHeaders.indexOf('Email'),
                  lastActiveIdx = detailedHeaders.indexOf('Last Login'),
                  resourcesAccessedIdx = summarisedHeaders.indexOf('Resources Accessed')

                var activationMap = {}
                userActivations.forEach(activation => {
                  activationMap[activation.email] = new Date(activation.activation_date)
                })

                detailedReport.forEach((detailedRow, idx) => {
                  var summarisedRow = summarisedReport[idx]
                  domain_user_list.push({
                    name: detailedRow[nameIdx],
                    email: detailedRow[emailIdx],
                    activation_date: activationMap[detailedRow[emailIdx]] || '-',
                    last_active: new Date(detailedRow[lastActiveIdx]),
                    resources_accessed: summarisedRow[resourcesAccessedIdx]
                  })
                })

                nameIdx = unactivatedHeaders.indexOf('Name')
                emailIdx = unactivatedHeaders.indexOf('Email')

                unactivatedReport.forEach(unactivatedRow => {
                  domain_user_list.push({
                    name: unactivatedRow[nameIdx],
                    email: unactivatedRow[emailIdx],
                    activation_date: '-',
                    last_active: '-',
                    resources_accessed: 0
                  })
                })

                $scope.domain_user_list = domain_user_list.sort(function(a, b) {
                  var aLower = a.name.toLowerCase()
                  var bLower = b.name.toLowerCase()

                  if (aLower < bLower) {
                    return -1
                  } else if (aLower > bLower) {
                    return 1
                  }

                  return 0
                })

                $scope.fetchingUsersReport = false
              },
              function(rejected) {
                console.error(rejected)
              }
            )
        }
        // -- Watches --

        // Selectable school month
        $scope.$watch('selectedSchoolYear', function(schoolYear) {
          var maxMonth = 11
          var i = 0

          if (schoolYear == new Date().getFullYear() && new Date().getMonth() >= 6) {
            maxMonth = new Date().getMonth() - 6
          } else if (schoolYear == new Date().getFullYear() + 1 && new Date().getMonth() < 6) {
            maxMonth = new Date().getMonth() + 7
          }

          $scope.schoolYearMonths = []
          for (i = 0; i <= maxMonth; i++) {
            $scope.schoolYearMonths.push({
              name: monthArray[i],
              value: monthVals[i]
            })
          }

          $scope.selectedMonth = $scope.schoolYearMonths[maxMonth]
        })

        $scope.$watch('selectedMonth', function(selectedMonth) {
          if (rawDomainsReport) {
            createDomainList(rawDomainsReport, selectedMonth)

            if ($scope.selected_domain_uuid) {
              createDomainUserList(
                $scope.productType,
                $scope.selected_domain_uuid,
                $scope.selectedSchoolYear,
                selectedMonth
              )
            }
          }
        })

        // -- Init --

        // Selectable school year
        $scope.schoolYears = (function() {
          var schoolYears = []
          var currentYear = new Date().getFullYear()

          if (new Date().getMonth() < 6) {
            currentYear -= 1
          }

          var startingYear = currentYear - 1

          for (; startingYear <= currentYear; startingYear++) {
            schoolYears.push({
              year: startingYear,
              label: ''.concat(startingYear, '-', startingYear - 1999)
            })
          }

          return schoolYears.reverse()
        })()

        $scope.selectedSchoolYear = $scope.schoolYears[0].year
        $scope.productType = 'toolkit'
        $scope.search_domain = {}
      }
    ]
  }
}
